// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e177675","239":"5f6e78c6","455":"ed05491b","488":"6668684d"}[chunkId] + ".chunk.js";
};